import { useEffect } from 'react';
import { getBapiService } from '../../../../../api_services/BapiService';
import { useAppStore } from '../../../../../store/appStore';

export const useLoadFlightMarkersLastModified = () => {
  const { selectedMission, getFlightMarkersLastModified, setFlightMarkersLastModified } = useAppStore();

  const customerId = selectedMission?.customer.id;
  const siteId = selectedMission?.site.id;

  useEffect(() => {
    if (!customerId || !siteId) return;

    const lastModified = getFlightMarkersLastModified(customerId, siteId);

    if (lastModified === undefined) {
      (async () => {
        const { lastModified } = await getBapiService().getFlightMarkersLastModified(customerId, siteId);
        setFlightMarkersLastModified(customerId, siteId, lastModified);
      })();
    }
  }, [customerId, siteId]);
};
